module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cookie-acceptance",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "cookie-acceptance-icon-wrapper"
  }, [_c('div', {
    staticClass: "cookie-acceptance-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "cookie-acceptance-text"
  }, [_vm._v("\n    This site uses cookies. By continuing to use the site, you agree to our "), _c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(" and use of cookies.\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-445614a9!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/molecules/cookie-acceptance/cookie-acceptance.vue
// module id = 699
// module chunks = 4